import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TiposSegmentoRoutingModule } from './tipos-segmento-routing.module';
import { FormsModule } from '@angular/forms';
import { AppSuiteRfbModule } from '../app-suite-rfb.module';
import { GerirTiposSegmentoComponent } from './componentes/gerir-tipos-segmento/gerir-tipos-segmento.component';
import { PainelEstiloSegmentoComponent } from './componentes/painel-estilo-segmento/painel-estilo-segmento.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
    declarations: [
        GerirTiposSegmentoComponent,
        PainelEstiloSegmentoComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        FormsModule,
        AppSuiteRfbModule,
        TiposSegmentoRoutingModule,
    ],
    exports: [
        PainelEstiloSegmentoComponent
    ]
})
export class TiposSegmentoModule { }
